import { debounce } from '@city-mattress/js-utils';

/**
 * Self Executing function to keep variables scoped locally to the fn
 */
(function () {
	let el = document.getElementById('cty-header-promo');
	let body = document.querySelector('body');

	let height = el.offsetHeight;

	/**
	 * Set the CSS propery on the document body
	 * @param height
	 */
	function setCssRootProperties(height) {
		body.style.setProperty('--header-promo-height', `${height}px`);
	}

	/**
	 * Add CSS variable for the header-promo-height on body element
	 */
	function addCssVariable() {
		height = el.offsetHeight;
		setCssRootProperties(height);
	}

	//dispatch instantly and then watch on resize
	window.addEventListener('resize', debounce(addCssVariable, 50));

	document.addEventListener('DOMContentLoaded', () => {
		addCssVariable();
	});
})();
